export default __webpack_public_path__ + "static/media/info_1.91c3a59b.jpg";